<template>
  <collapse v-if="byMonths.length > 0" cy-id="summary-table-dropdown">
    <collapse-item body-classes="p-0 m-0">
      <template slot="title">
        <h3 class="mb-0">
          <span>Resumen por Mes</span>
        </h3>
      </template>

      <div>
        <el-table :data="byMonths" cy-id="summary-table" header-row-class-name="thead-light">
          <el-table-column label="Mes" min-width="120px" prop="month">
            <template #default="{ row }">
              <span>{{ months[row.month] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Año" min-width="120px" prop="year">
            <template #default="{ row }">
              <span>{{ row.year }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Comisión" min-width="120px" prop="commissionUSD">
            <template #default="{ row }">
              <span cy-id="total-commission-usd">{{ row.commissionUSD | toCurrencyUSD }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Comisión en Pesos" min-width="120px" prop="commissionARS">
            <template #default="{ row }">
              <span cy-id="total-commission-ars">{{ row.commissionARS | toCurrencyARS }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Porcentaje" min-width="120px" prop="percentage">
            <template #default="{ row }">
              <span>{{ row.percentage | percentage }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </collapse-item>
  </collapse>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';
import { Table, TableColumn } from 'element-ui';
import { months } from '@/util/constants/months';

export default {
  name: 'LiquidationByMonths',
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  props: {
    isBySeller: {
      type: Boolean,
      required: true,
    },

    liquidated: {
      type: Boolean,
      required: true,
    },

    distributorSelected: {
      type: Number,
      default: 0,
    },

    sellerSelected: {
      type: Number,
      default: 0,
    },

    campaignSelected: {
      type: Number,
      default: 0,
    },

    startDate: {
      type: String,
      default: null,
    },

    endDate: {
      type: String,
      default: null,
    },

    searchQuery: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      months,
      byMonths: [],
    };
  },

  watch: {
    distributorSelected() {
      this.fetchData();
    },

    sellerSelected() {
      this.fetchData();
    },

    campaignSelected() {
      this.fetchData();
    },

    startDate() {
      this.fetchData();
    },

    searchQuery() {
      this.fetchData();
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      const params = {
        bySeller: this.isBySeller ? 1 : 0,
        liquidated: this.liquidated,
        seller: this.sellerSelected,
        distributor: this.distributorSelected,
        campaign: this.campaignSelected,
        startDate: this.startDate,
        endDate: this.endDate,
        search: this.searchQuery,
      };

      this.$services
        .resource('liquidations')
        .byMonths(params)
        .then((res) => {
          this.byMonths = res.data;
        });
    },
  },
};
</script>
